import PropTypes from 'prop-types';

/**
 * ViewModeToggle - Segmented Control "2D | 3D" im Editor-Sub-Header (#599)
 *
 * Bewusst ohne three-/R3F-Imports: wird eager im MainLayout gerendert,
 * während die eigentliche 3D-Ansicht lazy nachgeladen wird.
 *
 * @param {Object} props
 * @param {'2d'|'3d'} props.viewMode - Aktive Ansicht
 * @param {(mode: '2d'|'3d') => void} props.onChange
 * @param {string} [props.className='']
 */
const MODES = [
  { id: '2d', label: '2D' },
  { id: '3d', label: '3D' },
];

const ViewModeToggle = ({ viewMode, onChange, className = '' }) => {
  return (
    <div
      role="group"
      aria-label="Ansicht wechseln"
      className={`inline-flex items-center rounded-lg bg-gray-100 border border-gray-200 p-0.5 ${className}`}
    >
      {MODES.map((mode) => {
        const isActive = viewMode === mode.id;
        return (
          <button
            key={mode.id}
            type="button"
            aria-pressed={isActive}
            onClick={() => !isActive && onChange(mode.id)}
            className={`px-3 py-1.5 min-w-[44px] rounded-md text-sm font-medium transition-colors ${
              isActive
                ? 'bg-white text-emerald-700 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {mode.label}
          </button>
        );
      })}
    </div>
  );
};

ViewModeToggle.propTypes = {
  viewMode: PropTypes.oneOf(['2d', '3d']).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ViewModeToggle;
